module.exports = __webpack_public_path__ + "img/replayAttachmentNA.ea9f7c6c.svg";